import { gql } from 'apollo-boost';
import { STRUCTURED_CONTENT_FIELDS } from '../fragments/message/structured-content-fields';

export const NEW_MESSAGE_SUBSCRIPTION = gql`
    subscription($folderId: String) {
        newMessage(folderId: $folderId) {
            id
            contributionSource
            clientRequestId
            parentMessageId
            referencedMessageId
            threadRootMessageId
            email { subject from receivedAt preview hasOriginalHtml }
            laneKind
            aiRole
            aiProvider
            aiModel
            threadReplyCount
            threadChatCount
            threadMessageCount
            threadChatUpdatedAt
            threadMessageUpdatedAt
            threadActivityUpdatedAt
            inChatSession
            activityAt
            title
            body
            rank
            createdAt
            updatedAt
            deletedAt
            type {
                type
                format
            }
            image {
                url
                cdn_url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                name
                displayName
                type
                format
                size
                width
                height
                aspect_ratio
                public_id
            }
            file {
                url
                cdn_url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                name
                displayName
                type
                format
                size
                width
                height
                aspect_ratio
                duration
                mime
            }
            isCheckbox
            isChecked
            isStarred
            metadata {
                savedFrom { channel source method type }
                email { from subject receivedAt }
                highlight {
                    color
                    highlightId
                }
                audioProcessing {
                    status
                    outputFormat
                    error
                    startedAt
                    completedAt
                }
            }
            folder {
                id
                title
                owner
                parent
                isPinned
                pinnedRank
                deletedAt
            }
            urlMeta {
                author
                date
                description
                article_url
                article_body
                article_pull_provider
                reddit_comments {
                    author
                    body
                    score
                    created_utc
                    permalink
                }
                sourcePlatform
                sourceMetrics {
                    score
                    upvoteRatio
                    commentCount
                    createdUtc
                    viewCount
                    likeCount
                    shareCount
                    saveCount
                    engagementRate
                }
                sourcePlatformMeta {
                    reddit {
                        subreddit
                        permalink
                        over18
                        locked
                        stickied
                        postHint
                        isGallery
                    }
                }
                image
                image_asset_id
                gallery_images
                gallery {
                    type
                    image
                    image_name
                    image_asset_id
                    media_asset_id
                    media {
                        public_id
                        url
                        cdn_url
                        name
                        displayName
                        type
                        format
                        size
                        aspect_ratio
                        width
                        height
                        mime
                        duration
                        ocrText
                        ocrExtracted
                    }
                    width
                    height
                    aspect_ratio
                    media_url
                    media_name
                    media_cdn_url
                    media_hls_url
                    media_duration
                    media_has_audio
                }
                image_cdn_url
                image_name
                media_name
                media_asset_id
                media_audio_asset_id
                media_cdn_url
                media_url
                media_type
                media_width
                media_height
                media_duration
                media_has_audio
                media_audio_url
                media_hls_url
                logo
                publisher
                title
                url
                public_id
                width
                height
                format
                aspect_ratio
                size
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                author_image
                author_image_cdn_url
                author_image_public_id
                author_image_name
                author_image_size
                author_image_format
                author_image_aspect_ratio
                author_image_width
                author_image_height
                author_image_original
                author_image_thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                quoted_url_meta {
                    author
                    date
                    description
                    article_url
                    article_body
                    article_pull_provider
                    lang
                    image
                    image_asset_id
                    gallery_images
                    gallery {
                        type
                        image
                        image_name
                        image_asset_id
                        media_asset_id
                        media {
                            public_id
                            url
                            cdn_url
                            name
                            displayName
                            type
                            format
                            size
                            aspect_ratio
                            width
                            height
                            mime
                            duration
                            ocrText
                            ocrExtracted
                        }
                        width
                        height
                        aspect_ratio
                        media_url
                        media_name
                        media_cdn_url
                        media_hls_url
                        media_duration
                        media_has_audio
                    }
                    image_cdn_url
                    image_name
                    media_name
                    media_asset_id
                    media_audio_asset_id
                    media_cdn_url
                    media_url
                    media_type
                    media_width
                    media_height
                    media_duration
                    media_has_audio
                    media_audio_url
                    media_hls_url
                    logo
                    publisher
                    title
                    url
                    author_image
                    author_image_cdn_url
                    author_image_public_id
                    author_image_name
                    author_image_size
                    author_image_format
                    author_image_aspect_ratio
                    author_image_width
                    author_image_height
                    author_image_original
                }
                embed {
                    html
                    script {
                        src
                        async
                        charset
                    }
                }
            }
            reminderAt
            eventArtifactId
            event { startDate endDate startTime endTime timeZone location rawDate needsReview }
            reminderUpdatedAt
            reminderFiredAt
            reminderCancelledAt
            reminderVersion
            reminderDeliveryType
            reminderMessage
            automaticReminderNeedsReview
            dueAt
            dueTimezone
            dueKind

            dueSeriesEndAt
            alerts {
                id
                offsetMinutes
                deliveryType
                firedAt
            }
            suggestedFolderTitle
            caption
            keywords
            ocrText
            transcript {
                text
                source
                status
                sourceUrl
                urlMetaIndex
                provider
                model
                createdAt
                updatedAt
                segments {
                    start
                    end
                    text
                }
            }
            transcriptionSegments {
                start
                end
                text
            }
            ${STRUCTURED_CONTENT_FIELDS}
            entities {
                type
                name
                confidence
                enrichment {
                    image
                    width
                    height
                    aspect_ratio
                    description
                    year
                    url
                    source
                }
            }
        }
    }
`;
